import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const getPatientLists = async () => {
  const apiURL = API_HOST + '/admin/patient_lists';
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
